import { ChevronRight } from "lucide-react"

import { TOOLS } from "../../config/landing-content"
import { SectionTitle } from "../section-title"

interface ToolsSectionProps {
  onAction: () => void
}

export function ToolsSection({ onAction }: ToolsSectionProps) {
  return (
    <section data-slot="tools-section" className="flex flex-col gap-4 px-4">
      <SectionTitle>Explore Your Personal Guidance Tools</SectionTitle>

      {TOOLS.map((tool) => (
        <div
          key={tool.title}
          className="flex flex-col gap-3 overflow-hidden rounded-[16px] bg-dark-surface p-4"
        >
          <img src={tool.icon} alt="" className="size-10" />
          <div className="flex flex-col gap-1">
            <h3 className="font-display text-base font-medium text-purple-light">{tool.title}</h3>
            <p className="text-sm leading-snug text-purple-light/70">{tool.subtitle}</p>
          </div>
          <button
            type="button"
            onClick={onAction}
            className="flex w-fit items-center gap-2 rounded-full bg-purple-light/10 px-4 py-2 text-sm text-purple-light"
          >
            {tool.cta}
            <ChevronRight className="size-3.5" />
          </button>
        </div>
      ))}
    </section>
  )
}
